import Joi from 'joi';

export interface SchoolCandidateAppealRegistrationPaymentFormData {
  amount: number;
}

export const schemaSchoolCandidateAppealRegistrationPayment = Joi.object<SchoolCandidateAppealRegistrationPaymentFormData>({
  amount: Joi.number()
  .required()
  .greater(0)
  .max(99999.99)
  .messages({
    'any.required': 'Payment amount is not allowed to be empty.',
    'number.base': 'Invalid Amount',
    'number.greater': 'Invalid Amount',
  }),
});
